const DOJO_MODE = {
    WORKOUT: 'workout',
    // Belt test session selection, shown before proctoring and OTP validation
    BELT_SELECTION: 'belt_selection',
    BELT: 'belt',
}

export const isBeltMode = mode =>
    mode === DOJO_MODE.BELT || mode === DOJO_MODE.BELT_SELECTION

export default DOJO_MODE
